export default {"src":"/_next/static/media/scan.5c6cce41.svg","height":643,"width":1468,"blurWidth":0,"blurHeight":0};